const gradeMap: Record<string, string> = {
  ac: 'AC', acy: 'AC', acx: 'AC', ac0: 'AC', ac1: 'AC', ac2: 'AC', ac3: 'AC', ac4: 'AC', ac5: 'AC',
  c: 'C', cx: 'C', cy: 'C', c1: 'C', c2: 'C', c3: 'C', c4: 'C',
  m: 'M', mx: 'M', m1: 'M', m2: 'M', m3: 'M',
  ap: 'AP', apx: 'AP', ap1: 'AP', ap2: 'AP', ap3: 'AP',
  p: 'P', p1: 'P', p2: 'P', p3: 'P', p4: 'P', partner: 'P',
};

const gradeRanks: Record<string, number> = {
  AC: 1, C: 2, M: 3, AP: 4, P: 5,
};

export function getGradeRank(grade: string): number {
  const normalized = gradeMap[grade.toLowerCase()];
  return normalized ? gradeRanks[normalized] ?? 0 : 0;
}

export function getGradeFamily(grade: string | null | undefined): string | null {
  if (!grade) return null;
  return gradeMap[grade.toLowerCase()] ?? null;
}
